/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as NerveRouteImport } from './routes/nerve'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ContextRouteImport } from './routes/context'
import { Route as DevRouteRouteImport } from './routes/dev/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DevIndexRouteImport } from './routes/dev/index'
import { Route as SShareTokenRouteImport } from './routes/s.$shareToken'
import { Route as ProjectProjectIdRouteImport } from './routes/project.$projectId'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as DocDocIdRouteImport } from './routes/doc.$docId'
import { Route as DevWebScrapeRouteImport } from './routes/dev/web-scrape'
import { Route as DevStyleGuideRouteImport } from './routes/dev/style-guide'
import { Route as DevChatDebugRouteImport } from './routes/dev/chat-debug'
import { Route as DevApiExplorerRouteImport } from './routes/dev/api-explorer'
import { Route as ContentContentIdRouteImport } from './routes/content.$contentId'
import { Route as DevPrototypesRouteRouteImport } from './routes/dev/prototypes/route'
import { Route as DevPrototypesIndexRouteImport } from './routes/dev/prototypes/index'
import { Route as DevPrototypesTreesRouteImport } from './routes/dev/prototypes/trees'
import { Route as DevPrototypesLandingV1ComponentsRouteImport } from './routes/dev/prototypes/landing-v1-components'
import { Route as DevPrototypesLandingV1RouteImport } from './routes/dev/prototypes/landing-v1'
import { Route as DevPrototypesClearvoidV1ComponentsRouteImport } from './routes/dev/prototypes/clearvoid-v1-components'
import { Route as DevPrototypesClearvoidV1RouteImport } from './routes/dev/prototypes/clearvoid-v1'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const NerveRoute = NerveRouteImport.update({
  id: '/nerve',
  path: '/nerve',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ContextRoute = ContextRouteImport.update({
  id: '/context',
  path: '/context',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRouteRoute = DevRouteRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevIndexRoute = DevIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevRouteRoute,
} as any)
const SShareTokenRoute = SShareTokenRouteImport.update({
  id: '/s/$shareToken',
  path: '/s/$shareToken',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectProjectIdRoute = ProjectProjectIdRouteImport.update({
  id: '/project/$projectId',
  path: '/project/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const DocDocIdRoute = DocDocIdRouteImport.update({
  id: '/doc/$docId',
  path: '/doc/$docId',
  getParentRoute: () => rootRouteImport,
} as any)
const DevWebScrapeRoute = DevWebScrapeRouteImport.update({
  id: '/web-scrape',
  path: '/web-scrape',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevStyleGuideRoute = DevStyleGuideRouteImport.update({
  id: '/style-guide',
  path: '/style-guide',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevChatDebugRoute = DevChatDebugRouteImport.update({
  id: '/chat-debug',
  path: '/chat-debug',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevApiExplorerRoute = DevApiExplorerRouteImport.update({
  id: '/api-explorer',
  path: '/api-explorer',
  getParentRoute: () => DevRouteRoute,
} as any)
const ContentContentIdRoute = ContentContentIdRouteImport.update({
  id: '/content/$contentId',
  path: '/content/$contentId',
  getParentRoute: () => rootRouteImport,
} as any)
const DevPrototypesRouteRoute = DevPrototypesRouteRouteImport.update({
  id: '/prototypes',
  path: '/prototypes',
  getParentRoute: () => DevRouteRoute,
} as any)
const DevPrototypesIndexRoute = DevPrototypesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevPrototypesRouteRoute,
} as any)
const DevPrototypesTreesRoute = DevPrototypesTreesRouteImport.update({
  id: '/trees',
  path: '/trees',
  getParentRoute: () => DevPrototypesRouteRoute,
} as any)
const DevPrototypesLandingV1ComponentsRoute =
  DevPrototypesLandingV1ComponentsRouteImport.update({
    id: '/landing-v1-components',
    path: '/landing-v1-components',
    getParentRoute: () => DevPrototypesRouteRoute,
  } as any)
const DevPrototypesLandingV1Route = DevPrototypesLandingV1RouteImport.update({
  id: '/landing-v1',
  path: '/landing-v1',
  getParentRoute: () => DevPrototypesRouteRoute,
} as any)
const DevPrototypesClearvoidV1ComponentsRoute =
  DevPrototypesClearvoidV1ComponentsRouteImport.update({
    id: '/clearvoid-v1-components',
    path: '/clearvoid-v1-components',
    getParentRoute: () => DevPrototypesRouteRoute,
  } as any)
const DevPrototypesClearvoidV1Route =
  DevPrototypesClearvoidV1RouteImport.update({
    id: '/clearvoid-v1',
    path: '/clearvoid-v1',
    getParentRoute: () => DevPrototypesRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dev': typeof DevRouteRouteWithChildren
  '/context': typeof ContextRoute
  '/login': typeof LoginRoute
  '/nerve': typeof NerveRoute
  '/pricing': typeof PricingRoute
  '/signup': typeof SignupRoute
  '/dev/prototypes': typeof DevPrototypesRouteRouteWithChildren
  '/content/$contentId': typeof ContentContentIdRoute
  '/dev/api-explorer': typeof DevApiExplorerRoute
  '/dev/chat-debug': typeof DevChatDebugRoute
  '/dev/style-guide': typeof DevStyleGuideRoute
  '/dev/web-scrape': typeof DevWebScrapeRoute
  '/doc/$docId': typeof DocDocIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/s/$shareToken': typeof SShareTokenRoute
  '/dev/': typeof DevIndexRoute
  '/dev/prototypes/clearvoid-v1': typeof DevPrototypesClearvoidV1Route
  '/dev/prototypes/clearvoid-v1-components': typeof DevPrototypesClearvoidV1ComponentsRoute
  '/dev/prototypes/landing-v1': typeof DevPrototypesLandingV1Route
  '/dev/prototypes/landing-v1-components': typeof DevPrototypesLandingV1ComponentsRoute
  '/dev/prototypes/trees': typeof DevPrototypesTreesRoute
  '/dev/prototypes/': typeof DevPrototypesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/context': typeof ContextRoute
  '/login': typeof LoginRoute
  '/nerve': typeof NerveRoute
  '/pricing': typeof PricingRoute
  '/signup': typeof SignupRoute
  '/content/$contentId': typeof ContentContentIdRoute
  '/dev/api-explorer': typeof DevApiExplorerRoute
  '/dev/chat-debug': typeof DevChatDebugRoute
  '/dev/style-guide': typeof DevStyleGuideRoute
  '/dev/web-scrape': typeof DevWebScrapeRoute
  '/doc/$docId': typeof DocDocIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/s/$shareToken': typeof SShareTokenRoute
  '/dev': typeof DevIndexRoute
  '/dev/prototypes/clearvoid-v1': typeof DevPrototypesClearvoidV1Route
  '/dev/prototypes/clearvoid-v1-components': typeof DevPrototypesClearvoidV1ComponentsRoute
  '/dev/prototypes/landing-v1': typeof DevPrototypesLandingV1Route
  '/dev/prototypes/landing-v1-components': typeof DevPrototypesLandingV1ComponentsRoute
  '/dev/prototypes/trees': typeof DevPrototypesTreesRoute
  '/dev/prototypes': typeof DevPrototypesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dev': typeof DevRouteRouteWithChildren
  '/context': typeof ContextRoute
  '/login': typeof LoginRoute
  '/nerve': typeof NerveRoute
  '/pricing': typeof PricingRoute
  '/signup': typeof SignupRoute
  '/dev/prototypes': typeof DevPrototypesRouteRouteWithChildren
  '/content/$contentId': typeof ContentContentIdRoute
  '/dev/api-explorer': typeof DevApiExplorerRoute
  '/dev/chat-debug': typeof DevChatDebugRoute
  '/dev/style-guide': typeof DevStyleGuideRoute
  '/dev/web-scrape': typeof DevWebScrapeRoute
  '/doc/$docId': typeof DocDocIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/s/$shareToken': typeof SShareTokenRoute
  '/dev/': typeof DevIndexRoute
  '/dev/prototypes/clearvoid-v1': typeof DevPrototypesClearvoidV1Route
  '/dev/prototypes/clearvoid-v1-components': typeof DevPrototypesClearvoidV1ComponentsRoute
  '/dev/prototypes/landing-v1': typeof DevPrototypesLandingV1Route
  '/dev/prototypes/landing-v1-components': typeof DevPrototypesLandingV1ComponentsRoute
  '/dev/prototypes/trees': typeof DevPrototypesTreesRoute
  '/dev/prototypes/': typeof DevPrototypesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dev'
    | '/context'
    | '/login'
    | '/nerve'
    | '/pricing'
    | '/signup'
    | '/dev/prototypes'
    | '/content/$contentId'
    | '/dev/api-explorer'
    | '/dev/chat-debug'
    | '/dev/style-guide'
    | '/dev/web-scrape'
    | '/doc/$docId'
    | '/oauth/consent'
    | '/project/$projectId'
    | '/s/$shareToken'
    | '/dev/'
    | '/dev/prototypes/clearvoid-v1'
    | '/dev/prototypes/clearvoid-v1-components'
    | '/dev/prototypes/landing-v1'
    | '/dev/prototypes/landing-v1-components'
    | '/dev/prototypes/trees'
    | '/dev/prototypes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/context'
    | '/login'
    | '/nerve'
    | '/pricing'
    | '/signup'
    | '/content/$contentId'
    | '/dev/api-explorer'
    | '/dev/chat-debug'
    | '/dev/style-guide'
    | '/dev/web-scrape'
    | '/doc/$docId'
    | '/oauth/consent'
    | '/project/$projectId'
    | '/s/$shareToken'
    | '/dev'
    | '/dev/prototypes/clearvoid-v1'
    | '/dev/prototypes/clearvoid-v1-components'
    | '/dev/prototypes/landing-v1'
    | '/dev/prototypes/landing-v1-components'
    | '/dev/prototypes/trees'
    | '/dev/prototypes'
  id:
    | '__root__'
    | '/'
    | '/dev'
    | '/context'
    | '/login'
    | '/nerve'
    | '/pricing'
    | '/signup'
    | '/dev/prototypes'
    | '/content/$contentId'
    | '/dev/api-explorer'
    | '/dev/chat-debug'
    | '/dev/style-guide'
    | '/dev/web-scrape'
    | '/doc/$docId'
    | '/oauth/consent'
    | '/project/$projectId'
    | '/s/$shareToken'
    | '/dev/'
    | '/dev/prototypes/clearvoid-v1'
    | '/dev/prototypes/clearvoid-v1-components'
    | '/dev/prototypes/landing-v1'
    | '/dev/prototypes/landing-v1-components'
    | '/dev/prototypes/trees'
    | '/dev/prototypes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DevRouteRoute: typeof DevRouteRouteWithChildren
  ContextRoute: typeof ContextRoute
  LoginRoute: typeof LoginRoute
  NerveRoute: typeof NerveRoute
  PricingRoute: typeof PricingRoute
  SignupRoute: typeof SignupRoute
  ContentContentIdRoute: typeof ContentContentIdRoute
  DocDocIdRoute: typeof DocDocIdRoute
  OauthConsentRoute: typeof OauthConsentRoute
  ProjectProjectIdRoute: typeof ProjectProjectIdRoute
  SShareTokenRoute: typeof SShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nerve': {
      id: '/nerve'
      path: '/nerve'
      fullPath: '/nerve'
      preLoaderRoute: typeof NerveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/context': {
      id: '/context'
      path: '/context'
      fullPath: '/context'
      preLoaderRoute: typeof ContextRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/': {
      id: '/dev/'
      path: '/'
      fullPath: '/dev/'
      preLoaderRoute: typeof DevIndexRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/s/$shareToken': {
      id: '/s/$shareToken'
      path: '/s/$shareToken'
      fullPath: '/s/$shareToken'
      preLoaderRoute: typeof SShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId': {
      id: '/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof ProjectProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/doc/$docId': {
      id: '/doc/$docId'
      path: '/doc/$docId'
      fullPath: '/doc/$docId'
      preLoaderRoute: typeof DocDocIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/web-scrape': {
      id: '/dev/web-scrape'
      path: '/web-scrape'
      fullPath: '/dev/web-scrape'
      preLoaderRoute: typeof DevWebScrapeRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/style-guide': {
      id: '/dev/style-guide'
      path: '/style-guide'
      fullPath: '/dev/style-guide'
      preLoaderRoute: typeof DevStyleGuideRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/chat-debug': {
      id: '/dev/chat-debug'
      path: '/chat-debug'
      fullPath: '/dev/chat-debug'
      preLoaderRoute: typeof DevChatDebugRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/api-explorer': {
      id: '/dev/api-explorer'
      path: '/api-explorer'
      fullPath: '/dev/api-explorer'
      preLoaderRoute: typeof DevApiExplorerRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/content/$contentId': {
      id: '/content/$contentId'
      path: '/content/$contentId'
      fullPath: '/content/$contentId'
      preLoaderRoute: typeof ContentContentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/prototypes': {
      id: '/dev/prototypes'
      path: '/prototypes'
      fullPath: '/dev/prototypes'
      preLoaderRoute: typeof DevPrototypesRouteRouteImport
      parentRoute: typeof DevRouteRoute
    }
    '/dev/prototypes/': {
      id: '/dev/prototypes/'
      path: '/'
      fullPath: '/dev/prototypes/'
      preLoaderRoute: typeof DevPrototypesIndexRouteImport
      parentRoute: typeof DevPrototypesRouteRoute
    }
    '/dev/prototypes/trees': {
      id: '/dev/prototypes/trees'
      path: '/trees'
      fullPath: '/dev/prototypes/trees'
      preLoaderRoute: typeof DevPrototypesTreesRouteImport
      parentRoute: typeof DevPrototypesRouteRoute
    }
    '/dev/prototypes/landing-v1-components': {
      id: '/dev/prototypes/landing-v1-components'
      path: '/landing-v1-components'
      fullPath: '/dev/prototypes/landing-v1-components'
      preLoaderRoute: typeof DevPrototypesLandingV1ComponentsRouteImport
      parentRoute: typeof DevPrototypesRouteRoute
    }
    '/dev/prototypes/landing-v1': {
      id: '/dev/prototypes/landing-v1'
      path: '/landing-v1'
      fullPath: '/dev/prototypes/landing-v1'
      preLoaderRoute: typeof DevPrototypesLandingV1RouteImport
      parentRoute: typeof DevPrototypesRouteRoute
    }
    '/dev/prototypes/clearvoid-v1-components': {
      id: '/dev/prototypes/clearvoid-v1-components'
      path: '/clearvoid-v1-components'
      fullPath: '/dev/prototypes/clearvoid-v1-components'
      preLoaderRoute: typeof DevPrototypesClearvoidV1ComponentsRouteImport
      parentRoute: typeof DevPrototypesRouteRoute
    }
    '/dev/prototypes/clearvoid-v1': {
      id: '/dev/prototypes/clearvoid-v1'
      path: '/clearvoid-v1'
      fullPath: '/dev/prototypes/clearvoid-v1'
      preLoaderRoute: typeof DevPrototypesClearvoidV1RouteImport
      parentRoute: typeof DevPrototypesRouteRoute
    }
  }
}

interface DevPrototypesRouteRouteChildren {
  DevPrototypesClearvoidV1Route: typeof DevPrototypesClearvoidV1Route
  DevPrototypesClearvoidV1ComponentsRoute: typeof DevPrototypesClearvoidV1ComponentsRoute
  DevPrototypesLandingV1Route: typeof DevPrototypesLandingV1Route
  DevPrototypesLandingV1ComponentsRoute: typeof DevPrototypesLandingV1ComponentsRoute
  DevPrototypesTreesRoute: typeof DevPrototypesTreesRoute
  DevPrototypesIndexRoute: typeof DevPrototypesIndexRoute
}

const DevPrototypesRouteRouteChildren: DevPrototypesRouteRouteChildren = {
  DevPrototypesClearvoidV1Route: DevPrototypesClearvoidV1Route,
  DevPrototypesClearvoidV1ComponentsRoute:
    DevPrototypesClearvoidV1ComponentsRoute,
  DevPrototypesLandingV1Route: DevPrototypesLandingV1Route,
  DevPrototypesLandingV1ComponentsRoute: DevPrototypesLandingV1ComponentsRoute,
  DevPrototypesTreesRoute: DevPrototypesTreesRoute,
  DevPrototypesIndexRoute: DevPrototypesIndexRoute,
}

const DevPrototypesRouteRouteWithChildren =
  DevPrototypesRouteRoute._addFileChildren(DevPrototypesRouteRouteChildren)

interface DevRouteRouteChildren {
  DevPrototypesRouteRoute: typeof DevPrototypesRouteRouteWithChildren
  DevApiExplorerRoute: typeof DevApiExplorerRoute
  DevChatDebugRoute: typeof DevChatDebugRoute
  DevStyleGuideRoute: typeof DevStyleGuideRoute
  DevWebScrapeRoute: typeof DevWebScrapeRoute
  DevIndexRoute: typeof DevIndexRoute
}

const DevRouteRouteChildren: DevRouteRouteChildren = {
  DevPrototypesRouteRoute: DevPrototypesRouteRouteWithChildren,
  DevApiExplorerRoute: DevApiExplorerRoute,
  DevChatDebugRoute: DevChatDebugRoute,
  DevStyleGuideRoute: DevStyleGuideRoute,
  DevWebScrapeRoute: DevWebScrapeRoute,
  DevIndexRoute: DevIndexRoute,
}

const DevRouteRouteWithChildren = DevRouteRoute._addFileChildren(
  DevRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DevRouteRoute: DevRouteRouteWithChildren,
  ContextRoute: ContextRoute,
  LoginRoute: LoginRoute,
  NerveRoute: NerveRoute,
  PricingRoute: PricingRoute,
  SignupRoute: SignupRoute,
  ContentContentIdRoute: ContentContentIdRoute,
  DocDocIdRoute: DocDocIdRoute,
  OauthConsentRoute: OauthConsentRoute,
  ProjectProjectIdRoute: ProjectProjectIdRoute,
  SShareTokenRoute: SShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
